// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/combos/salvar.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Combos_SalvarResponseDados {
so_combo_id: number
}

export type Combos_SalvarResponse = ApiResponse<Combos_SalvarResponseDados>;

registerResponseContract('Combos_SalvarResponse', {
  so_combo_id: { type: 'number',  required: true },
})
